var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-card",
        {
          staticClass: "border-secondary rounded p-3",
          attrs: { "no-body": "" }
        },
        [
          _c(
            "b-navbar",
            [
              _c("h5", { staticClass: "m-0 mr-auto" }, [_vm._v("График")]),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  staticClass: "mr-1",
                  attrs: {
                    id: "chart-bar",
                    size: "sm",
                    variant:
                      _vm.config.type === "bar" ? "warning" : "outline-warning"
                  },
                  on: {
                    click: function($event) {
                      return _vm.setChartType("bar")
                    }
                  }
                },
                [_c("font-awesome-icon", { attrs: { icon: "chart-bar" } })],
                1
              ),
              _vm._v(" "),
              _c(
                "b-tooltip",
                {
                  attrs: {
                    target: "chart-bar",
                    triggers: "hover",
                    variant: "warning",
                    noninteractive: ""
                  }
                },
                [_vm._v("\n        Столбчатый\n      ")]
              ),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  staticClass: "mr-1",
                  attrs: {
                    id: "chart-line",
                    size: "sm",
                    variant:
                      _vm.config.type === "line" ? "warning" : "outline-warning"
                  },
                  on: {
                    click: function($event) {
                      return _vm.setChartType("line")
                    }
                  }
                },
                [_c("font-awesome-icon", { attrs: { icon: "chart-line" } })],
                1
              ),
              _vm._v(" "),
              _c(
                "b-tooltip",
                {
                  attrs: {
                    target: "chart-line",
                    triggers: "hover",
                    variant: "warning",
                    noninteractive: ""
                  }
                },
                [_vm._v("\n        Линейный\n      ")]
              ),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  staticClass: "mr-1",
                  attrs: {
                    id: "chart-pie",
                    size: "sm",
                    variant:
                      _vm.config.type === "pie" ? "warning" : "outline-warning"
                  },
                  on: {
                    click: function($event) {
                      return _vm.setChartType("pie")
                    }
                  }
                },
                [_c("font-awesome-icon", { attrs: { icon: "chart-pie" } })],
                1
              ),
              _vm._v(" "),
              _c(
                "b-tooltip",
                {
                  attrs: {
                    target: "chart-pie",
                    triggers: "hover",
                    variant: "warning",
                    noninteractive: ""
                  }
                },
                [_vm._v("\n        Круговая\n      ")]
              ),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  staticClass: "text-dark",
                  attrs: { variant: "outline-warning", size: "sm" },
                  on: {
                    click: function($event) {
                      return _vm.openConfig()
                    }
                  }
                },
                [
                  _c("font-awesome-icon", {
                    staticClass: "mr-1",
                    attrs: { icon: "cogs" }
                  }),
                  _vm._v("\n        Настроить\n      ")
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.chartReady && _vm.isPerPageAllowed
            ? _c("e-charts", {
                attrs: { "chart-id": _vm.chartId, options: _vm.chartOptions }
              })
            : _c(
                "div",
                { staticClass: "text-center text-muted py-5" },
                [
                  _c("font-awesome-icon", {
                    staticClass: "mr-1",
                    attrs: { icon: "times-circle" }
                  }),
                  _vm._v(
                    "\n      Нет данных для отображения или количество записей на странице не поддерживается (максимум 50 записей).\n    "
                  )
                ],
                1
              )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "modal_chart_config",
          attrs: {
            id: "modal-chart-config",
            title: "Настройка графика",
            size: "md",
            "button-size": "sm",
            "ok-title": "Применить",
            "cancel-title": "Назад",
            "ok-variant": "success",
            centered: "",
            scrollable: "",
            "no-close-on-backdrop": "",
            "no-close-on-esc": ""
          },
          on: {
            ok: function($event) {
              return _vm.applyConfig()
            }
          },
          model: {
            value: _vm.showModalConfig,
            callback: function($$v) {
              _vm.showModalConfig = $$v
            },
            expression: "showModalConfig"
          }
        },
        [
          _c(
            "b-form-group",
            { attrs: { id: "xAxis", label: "Ось X (Категории)" } },
            [
              _c(
                "b-form-select",
                {
                  model: {
                    value: _vm.config.xKey,
                    callback: function($$v) {
                      _vm.$set(_vm.config, "xKey", $$v)
                    },
                    expression: "config.xKey"
                  }
                },
                _vm._l(_vm.xFields, function(f) {
                  return _c(
                    "option",
                    { key: f.key, domProps: { value: f.key } },
                    [_vm._v("\n          " + _vm._s(f.label) + "\n        ")]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c(
                "b-form-checkbox",
                {
                  staticClass: "mt-2",
                  attrs: { switch: "" },
                  model: {
                    value: _vm.config.isAggregated,
                    callback: function($$v) {
                      _vm.$set(_vm.config, "isAggregated", $$v)
                    },
                    expression: "config.isAggregated"
                  }
                },
                [
                  _vm._v(
                    "\n        Суммировать по одинаковым категориям\n      "
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-group",
            { attrs: { id: "yAxis", label: "Ось Y (Значения)" } },
            [
              _c(
                "b-form-select",
                {
                  model: {
                    value: _vm.config.yKey,
                    callback: function($$v) {
                      _vm.$set(_vm.config, "yKey", $$v)
                    },
                    expression: "config.yKey"
                  }
                },
                _vm._l(_vm.yFields, function(f) {
                  return _c(
                    "option",
                    { key: f.key, domProps: { value: f.key } },
                    [_vm._v("\n          " + _vm._s(f.label) + "\n        ")]
                  )
                }),
                0
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3566bd86", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// /home/el/code/sverkasoft-erp/frontend/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3566bd86","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!/home/el/code/sverkasoft-erp/frontend/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/utilites/commonUi/EChartBuilder.vue
// module id = null
// module chunks = 